import React from "react";
import Input from "./Input";

//Dubbed || Subtle Only
export default function MovieAudioType({ name = "audio_version", label = "Audio Type", required, disabled, defaultValue }) {
  const options = [
    { label: "Subtle Only", value: "Subtle Only" },
    { label: "Dubbed", value: "Dubbed" }
  ];

  return (
    <Input
      name={name}
      label={label}
      options={options}
      required={required}
      disabled={disabled}
      defaultValue={defaultValue}
      placeholder={"Select audio type"}
    />
  );
}
